import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginationFilterRequest, PaginatedSelectModel } from "@/models/core.model";
import { Story, StoryList, StoryPaginationFilterRequest, UpsertStory } from '@/models/story.model';

export const getPagedStories = async (input: StoryPaginationFilterRequest): Promise<PagedResponseModel<StoryList>> => {
  return await getReq(createUrl("a/Story/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getStoriesLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedStories(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `${itm.name} ${itm.city || itm.country ? `(${itm.city?.name || itm.country?.name})` : ''}`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getStory = async (id: number): Promise<BaseResponseModel<Story>> => {
  return await getReq(createUrl(`a/Story/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertStory = async (input: UpsertStory): Promise<BaseResponseModel<Story>> => {
  return await postReq(createUrl("a/Story/Upsert"),
    input
  ).then((res: any) => res.data);
};
